/**
 * Chuẩn hóa hiển thị và so sánh Đơn vị tính (ĐVT) trên toàn ERP:
 * - Lowercase toàn bộ trước khi xử lý (không phân biệt hoa/thường: 'Tấm' -> 'tấm')
 * - m3, M3, m³, M³ -> m³ (U+00B3)
 * - m2, M2, m², M² -> m² (U+00B2)
 * - m, M, mét, met, md, m.d, mét dài -> m (đơn vị mét dài chuẩn)
 * - Đơn vị ghép chứa /m3 hoặc /m2 (ví dụ kg/m3 -> kg/m³)
 * - Các đơn vị khác (cái, tấm, bộ, thùng, kg, mm, cuộn...) đưa về lowercase chuẩn hóa.
 */
export function normalizeUomLabel(input: string | null | undefined): string {
  if (input === null || input === undefined) return ''
  const trimmed = input.trim()
  if (!trimmed) return ''

  const lower = trimmed.toLowerCase()

  // Thể tích
  if (lower === 'm3' || lower === 'm³') return 'm³'

  // Diện tích
  if (lower === 'm2' || lower === 'm²') return 'm²'

  // Chiều dài / mét
  if (
    lower === 'm' ||
    lower === 'mét' ||
    lower === 'met' ||
    lower === 'md' ||
    lower === 'm.d' ||
    lower === 'mét dài' ||
    lower === 'met dai'
  ) {
    return 'm'
  }

  // Đơn vị ghép có /m3 hoặc /m2 (ví dụ: kg/m3 -> kg/m³, vnd/m3 -> vnd/m³)
  if (/(?:^|\/)\s*m3\b/i.test(trimmed) || /(?:^|\/)\s*m³\b/i.test(trimmed)) {
    return lower.replace(/(^|\/)\s*(?:m3|m³)\b/gi, '$1m³')
  }
  if (/(?:^|\/)\s*m2\b/i.test(trimmed) || /(?:^|\/)\s*m²\b/i.test(trimmed)) {
    return lower.replace(/(^|\/)\s*(?:m2|m²)\b/gi, '$1m²')
  }

  return lower
}
